import { Router } from "@frui.ts/screens/dist";
import { computed } from "mobx";
import { Modules } from "config";
import SystemComponent from "entities/systemComponent";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import EnumRepository from "repositories/enumRepository";
import ListViewModel from "../../listViewModel";
import SystemComponentCreateViewModel from "./systemComponentCreateViewModel";
import SystemComponentDetailViewModel from "./systemComponentDetailViewModel";
import type SystemComponentState from "entities/systemComponentState";

const navigationName = "system-components";

@Router.registerRoute({
  route: navigationName,
  name: Router.Self,
  children: [SystemComponentDetailViewModel, SystemComponentCreateViewModel],
})
export default class SystemComponentsViewModel extends ListViewModel<
  SystemComponent,
  SystemComponentDetailViewModel,
  SystemComponentCreateViewModel
> {
  readonly modelName = "systemComponent";

  @computed
  get allowWrite() {
    return false;
  }

  @computed
  get name() {
    return this.translate("name");
  }

  constructor(
    protected detailViewModelFactory: ReturnType<typeof SystemComponentDetailViewModel.Factory>,
    protected createViewModelFactory: () => SystemComponentCreateViewModel,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.postAll("system_components", SystemComponent, { offset, limit });
  }

  delete(item: SystemComponent) {
    return this.repository.delete(item, "system_components");
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.administration, `systemComponents.${code}`, size);
  }

  translateState(state: SystemComponentState) {
    return this.localizationService.translateEnum("systemComponentState", state);
  }
}
